import TablePagination from '@/components/Table/TablePagination';
import { TablePaginationOwnProps } from '@mui/material';
import { gridPaginationModelSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import classNames from 'classnames';
import { ChangeEvent, useCallback, useMemo } from 'react';
import LoadingBackdrop from '../LoadingBackdrop';

interface IProps extends TablePaginationOwnProps {
  loading?: boolean;
  rowCount: number;
  rowsPerPageOptions?: number[];
}

const ServerSidePagination = ({ loading, rowCount, className, rowsPerPageOptions = [15, 25, 50] }: IProps) => {
  const apiRef = useGridApiContext();
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);

  const pageCount = useMemo(
    () => Math.ceil(rowCount / (paginationModel.pageSize || 1)),
    [rowCount, paginationModel.pageSize],
  );
  const handlePageSizeChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const pageSize = Number(event.target.value);
      apiRef.current.setPageSize(pageSize);
    },
    [apiRef],
  );
  const handlePageChange = useCallback(
    (_: ChangeEvent, page: number) => {
      apiRef.current.setPage(page);
    },
    [apiRef],
  );

  const page = paginationModel.page < pageCount ? paginationModel.page + 1 : pageCount;
  const start = (page - 1) * paginationModel.pageSize;
  const end = Math.min(rowCount, page * paginationModel.pageSize);

  return (
    <>
      <TablePagination
        className={classNames('w-full relative print:hidden', className)}
        totalPages={pageCount}
        rowsPerPage={paginationModel.pageSize}
        total={rowCount}
        rowsPerPageOptions={rowsPerPageOptions}
        page={page}
        start={Math.max(0, start + 1 || 0)}
        end={end}
        onPageChange={(event, newPage) => {
          handlePageChange(event, newPage - 1);
        }}
        handleChangeRowsPerPage={handlePageSizeChange}
      />
      {loading ? <LoadingBackdrop /> : null}
    </>
  );
};

export default ServerSidePagination;
